import React from 'react';
import './App.css';
import WordmarkWhite from './assets/branding/wordmark_white.svg';
import BriefcaseWhite from './assets/icons/briefcase_white.svg';
import InstagramWhite from './assets/icons/instagram_white.svg';
import LinkedInWhite from './assets/icons/linkedin_white.svg';
import BackgroundImageCarousel from './components/BackgroundImageCarousel';

function App() {
  return (
    <div className="App">
      <BackgroundImageCarousel />
      <header className="App-header">
        <img src={WordmarkWhite} className="App-logo" alt="aideon" />
      </header>
      <section className="App-center">
        <p className="App-title">creative</p>
        <p className="App-subtitle">media, fashion, & design</p>
      </section>
      <section className="App-socials">
        <a
          className="App-social-link"
          href="#work"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={BriefcaseWhite} alt="Instagram" className="App-social-icon" /> work
        </a>
        <a
          className="App-social-link"
          href="https://www.instagram.com/aideonquek"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={InstagramWhite} alt="Instagram" className="App-social-icon" /> instagram
        </a>
        <a
          className="App-social-link"
          href="https://www.linkedin.com/in/aideon"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={LinkedInWhite} alt="LinkedIn" className="App-social-icon" /> linkedin
        </a>
      </section>
    </div>
  );
}

export default App;
